export const locale = {
    lang: 'pl',
    data: {
        'Reservations': 'Rezerwacje',
    }
};
